var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardStack = function SvgCardStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D9E9",
    fillRule: "evenodd",
    d: "M41.666 72.478C21.748 72.478 5.5 56.233 5.5 36.314 5.499 16.396 21.748.146 41.666.146s36.168 16.25 36.168 36.168c0 19.919-16.25 36.164-36.168 36.164",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CBDD",
    fillRule: "evenodd",
    d: "M11.932 36.314a36 36 0 0 0 6.031 20.008 36.3 36.3 0 0 0 5.088 6.083c5.775 5.545 13.387 9.188 21.832 9.932q-1.59.14-3.217.14a36.3 36.3 0 0 1-5.826-.465C18.634 69.227 5.499 54.302 5.499 36.314 5.499 16.34 21.692.146 41.667.146q1.627 0 3.216.141c-18.47 1.628-32.951 17.134-32.951 36.027",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EAF3",
    fillRule: "evenodd",
    d: "M41.666 39.8c13.029 0 23.755 9.871 25.113 22.541-6.506 6.275-15.357 10.137-25.113 10.137a36.067 36.067 0 0 1-25.109-10.136C17.913 49.666 28.638 39.8 41.668 39.8",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DFEE",
    fillRule: "evenodd",
    d: "M44.878 40.005C29.847 41.915 23.79 53.29 22.397 66.92a36 36 0 0 1-5.84-4.579C17.913 49.667 28.638 39.8 41.668 39.8q1.633 0 3.211.205",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41.666 39.431c-6.93 0-12.581-5.651-12.581-12.577 0-6.93 5.65-12.578 12.581-12.578 6.927 0 12.578 5.647 12.578 12.578 0 6.926-5.651 12.577-12.578 12.577",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FB",
    fillRule: "evenodd",
    d: "M32.253 26.854c0 6.413 4.797 11.702 10.996 12.48q-.779.096-1.583.097c-6.947 0-12.577-5.63-12.577-12.577s5.63-12.578 12.577-12.578q.804.001 1.583.097c-6.199.779-10.996 6.068-10.996 12.48",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M16.054 47.653 1.124 73.012a6.53 6.53 0 0 0 0 6.685c1.228 2.087 3.452 3.343 5.906 3.343h29.853c2.454 0 4.675-1.256 5.903-3.343a6.53 6.53 0 0 0 0-6.685l-14.927-25.36c-1.227-2.086-3.448-3.345-5.903-3.345s-4.675 1.259-5.902 3.346",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD4755",
    fillRule: "evenodd",
    d: "M22.867 44.365a7 7 0 0 0-.91-.058c-2.455 0-4.676 1.259-5.903 3.345l-14.93 25.36a6.53 6.53 0 0 0 0 6.685c1.228 2.087 3.452 3.342 5.906 3.342h1.82c-2.454 0-4.678-1.255-5.906-3.342a6.53 6.53 0 0 1 0-6.685l14.93-25.36a6.77 6.77 0 0 1 4.993-3.287",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF5",
    fillRule: "evenodd",
    d: "m19.132 49.394-14.93 25.36a3.11 3.11 0 0 0 0 3.201 3.24 3.24 0 0 0 2.828 1.601h29.853a3.23 3.23 0 0 0 2.825-1.6 3.11 3.11 0 0 0 0-3.203l-14.926-25.36c-.592-1.007-1.642-1.6-2.825-1.6-1.187 0-2.234.593-2.825 1.6",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    fillRule: "evenodd",
    d: "M35.063 79.556h1.82a3.23 3.23 0 0 0 2.825-1.6 3.11 3.11 0 0 0 0-3.203l-14.926-25.36c-.592-1.007-1.642-1.6-2.825-1.6q-.475.001-.91.122a3.2 3.2 0 0 1 1.915 1.479l14.927 25.36a3.11 3.11 0 0 1 0 3.201 3.23 3.23 0 0 1-2.826 1.601",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M21.956 69.178c.898 0 1.632-.695 1.664-1.576l.424-11.438a1.58 1.58 0 0 0-.467-1.195q-.494-.499-1.2-.5h-.841c-.47 0-.876.168-1.2.5a1.56 1.56 0 0 0-.467 1.195l.42 11.438c.032.88.77 1.576 1.667 1.576M21.956 75.554c-1.175 0-2.133-.94-2.133-2.093s.958-2.093 2.133-2.093 2.134.94 2.134 2.093-.958 2.093-2.134 2.093",
    clipRule: "evenodd"
  })));
};
export default SvgCardStack;